<template> 
  <v-col cols="3">
    <input	
      ref="inputFile"									
      type="file"
      @change="excelExport"
      id="excelFile"								
      accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    />
    <v-btn color="primary" @click="$refs.inputFile.click()" class="ma-2" >From File</v-btn> 
  </v-col>
</template>

<script>
import XLSX from 'xlsx';
import { mapGetters, mapActions } from 'vuex';

export default {
  data(){
    return{
      excelData: null,
      rlEntriesHeaders2: [
        'entry_type_id', 'trans_date', 'coll_dest_company', 'coll_dest_country', 'coll_dest_city', 'coll_dest_address',
        'coll_dest_contact_name', 'coll_dest_contact_tel', 'coll_dest_contact_email', 'material_id', 'grade_id', 'spec' ,'cont_perc',
        'material_volume', 'material_uom', 'material_unit_price_cc', 'material_unit_price', 'incoterm_id', 'PRN_PERN_price_cc',
        'PRN_PERN_price', 'dom_haul_cost_cc', 'dom_haul_cost', 'dom_haul_company', 'dom_haul_booked', 'dom_haul_date', 'int_ship_cost_cc',
        'int_ship_cost', 'int_ship_company', 'int_ship_booked', 'int_ship_date', 'insurance_cost_cc', 'insurance_cost','hs2','insp_company',
        'insp_cost_cc', 'insp_cost', 'FX_cc', 'FX_rate', 'other_costs_desc', 'other_costs_cc', 'other_costs', 'notes'
      ],    
    }
  },
  watch: {   
		excelData: {
			handler() {		
				this.handleAddExcelData()
			}
		},	
	},
  methods:{    
    changeLoading(isLoading){
      this.$emit('changeIsLoading', isLoading)
    },
    validateForm(){
      this.$emit('validateForm')
    },
    setIsNumber(data, variable){
      if(data[`${variable}`]){
        let itemNumber = data[`${variable}`];             
        if( !(this.isFloat(itemNumber)) ) itemNumber = (itemNumber).toFixed(2)     
        if( !(itemNumber && !isNaN(itemNumber)) ) data[`${variable}`] = null;
        data[`${variable}`] = itemNumber       
      }
    },
    isFloat(n){     
      return Number(n) === n && n % 1 !== 0;
    },
    addValidateExcelData(data) {      
      let newData = data;	
      this.setIsNumber(newData, 'FX_rate')
      this.setIsNumber(newData, 'insurance_cost')
      this.setIsNumber(newData, 'cont_perc')  
      this.setIsNumber(newData, 'material_volume')
      this.setIsNumber(newData, 'material_unit_price' )
      this.setIsNumber(newData, 'PRN_PERN_price' )
      this.setIsNumber(newData, 'dom_haul_cost' )   
      this.setIsNumber(newData, 'int_ship_cost' )    
      this.setIsNumber(newData, 'insp_cost' )
      this.setIsNumber(newData, 'other_costs' )

      if(data.coll_dest_country){
        const coll_dest_country = this.getCountryList.find(x => x.name == data.coll_dest_country).code
        if(coll_dest_country) newData.coll_dest_country = coll_dest_country
      }   
      this.setValidateExcelData(newData, 'entry_type_id', this.getEntryTypeList, 'description')     
      this.setValidateExcelData(newData, 'material_unit_price_cc', this.getCurrencyList, 'code')
      if(data.material_id) {
        const material_id = this.getMaterialList.find(x => x.description == data.material_id).id
        if(material_id) {
          newData.material_id = material_id
          if(data.grade_id) {
            const grade_id = this.getGradeMaterialList(material_id).find(x => x.description == data.grade_id).id
            if(grade_id) newData.grade_id = grade_id
          }   
        }
      }      
      this.setValidateExcelData(newData, 'incoterm_id', this.getIncotermList, 'description')
      this.setValidateExcelData(newData, 'PRN_PERN_price_cc', this.getCurrencyList, 'code')
      this.setValidateExcelData(newData, 'dom_haul_cost_cc', this.getCurrencyList, 'code')
      this.setValidateExcelData(newData, 'int_ship_cost_cc', this.getCurrencyList, 'code')    
      this.setValidateExcelData(newData, 'insurance_cost_cc', this.getCurrencyList, 'code')
      this.setValidateExcelData(newData, 'insp_cost_cc', this.getCurrencyList, 'code')
      this.setValidateExcelData(newData, 'other_costs_cc', this.getCurrencyList, 'code')
      this.setValidateExcelData(newData, 'FX_cc', this.getCurrencyList, 'code')    

      if(!data.dom_haul_booked) newData.dom_haul_booked = 0;
      if(!data.int_ship_booked) newData.int_ship_booked = 0;
      if(data.int_ship_date) newData.int_ship_date = new Date(Math.round((newData.int_ship_date - 25569)*86400*1000)).toISOString().slice(0,10);	 
      if(data.dom_haul_date) newData.dom_haul_date = new Date(Math.round((newData.dom_haul_date - 25569)*86400*1000)).toISOString().slice(0,10);			
			if(data.trans_date) newData.trans_date = new Date(Math.round((newData.trans_date - 25569)*86400*1000)).toISOString().slice(0,10);				
      newData.images = {shownImages: [], savedImages: []}
			return newData;
    },	   
    setValidateExcelData(newData, name, getFunction, variable) {
      if(newData[`${name}`]){
        const currency = getFunction.find(x => x[`${variable}`] == newData[`${name}`]).id
        if(currency) newData[`${name}`] = currency;
      }
    },
    getGradeMaterialList(id) {
			return this.getGradeList.filter(x => x.material_id === id)
    },
    async excelExport(event) {    
      this.changeLoading(true)
			const input = event.target;
      const reader = new FileReader();
      try{
        reader.onload = () => {
          const fileData = reader.result;        
          const wb = XLSX.read(fileData, {type : 'binary'});         
          wb.SheetNames.forEach( e => {             
            const rowObj = XLSX.utils.sheet_to_json(wb.Sheets['Import'], {header: this.rlEntriesHeaders2, range: 1, blankrows: false});	            
            this.excelData = rowObj;          
          })
        };
        reader.readAsBinaryString(input.files[0]);	
      } catch(error) {       
        this.changeLoading(false)
      }
		},
		async handleAddExcelData() {	         
      try {	         
        let excelData = [];						 	
        this.excelData.forEach(entry => {                   
          const newEntry = this.addValidateExcelData(entry)			
          excelData.push(newEntry)         		              
        })                	
        excelData && await this.setRlAddDialogList(excelData)   
        this.validateForm()      
        this.changeLoading(false) 	         
      }
      catch(error) {  
        this.changeLoading(false)       
      }			          
    },  
    ...mapActions([
      'setRlEntryAddDialogView2',
      'setRlAddDialog',
      'setRlEntryList',
      'setRlAddDialogList',
      'deleteRlAddDialogList',
      'setRlImageAddDialog',
      'setCompanyList',
      'setHs2List',
			'setDomesticCompanyList',
			'setShippingCompanyList',
      'setInspectionCompanyList',
      'clearRlAddDialogList'
		])
  },
  computed: {
    ...mapGetters([
      'getRlEntryAddDialogView2',
      'getUser',
			'getRlEntry',
      'getRlAddDialog',
      'getRlAddDialogList',
      'getEntryTypeList',
      'getMaterialList',
      'getGradeList',
      'getUnitOfMeasureList',
      'getCurrencyList',
      'getHs2List',
      'getDomesticCompanyList',
      'getShippingCompanyList',
      'getInspectionCompanyList',
      'getCountryList',
      'getIncotermList',
      'getCompanyList',
      'getRlDialogRules'
    ]),
  }
}
</script>

<style scoped>
	input[type="file"] {
		display: none;		
	}	 
</style>